var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"completed"}},[_c('span',{attrs:{"id":"completed-label"}},[_vm._v("Completed")]),_c('TaskList',{attrs:{"id":"task-list","sourceList":_vm.complete,"reverse":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }